import { CHATBOT, PAGE_NOT_AUTHORIZED, PAGE_NOT_FOUND } from './constants';
import pages from './pages';

const getPageNotAuthorizedPath = () => {
  return pages[PAGE_NOT_AUTHORIZED].path;
};

const getPageNotFoundPath = () => {
  return pages[PAGE_NOT_FOUND].path;
};

const getPageByPath = (path) => {
  // Just normalize trailing slash for chatbot (new tab can become /chatbot/)
  const chatbotPath = pages[CHATBOT]?.path;
  const pathToUse =
    chatbotPath && path === `${chatbotPath}/` ? path.slice(0, -1) : path;

  const currentId = Object.keys(pages).find(
    (screenId) =>
      pages[screenId].path === pathToUse ||
      (pages[screenId].pathRegex &&
        new RegExp(pages[screenId].pathRegex).test(path))
  );
  if (currentId) {
    return pages[currentId];
  }
  return null;
};

const getModeByPath = (path) => {
  const page = getPageByPath(path);
  if (page) {
    const matches = page.path.match(/^.*?(?=:)/);
    return matches ? path.replace(matches[0], '') : null;
  }
  return null;
};

export {
  getPageNotAuthorizedPath,
  getPageNotFoundPath,
  getPageByPath,
  getModeByPath,
};
